export enum res {
  Update,
  SelectOrganization,
  Loading,
  LoadingInfo,
  LoadingUserData,
  TitleDashboard,
  ActivityNotCreated,
  TitleClosing,
  TitleOpening,
  TitleCoordinator,
  CompletedDashboard,
  StoresOf,
  Stores,
  InventoryManagement,
  MerchandiseEntry,
  Reception,
  Income,
  CorporateTransfer,
  Return,
  Units,
  Inventories,
  Differences,
  Pcs,
  Cost,
  Execution,
  ChangeMarketingCampaign,
  ChangeMarketingCampaignUSA,
  UpdatePrices,
  StoreType,
  StoreLocation,
  Department,
  DetailType,
  SelectItem,
  Campaign,
  SupervisorZones,
  BrandDepartment,
  BrandGender,
  CompletedComply,
  NotCompletedComply,
  VisualExecutiveZones,
  VisualZones,
  AuditorZones,
  TotalRating,
  StoresVisited,
  ByCategory,
  ByRegion,
  Zones,
  StoresMayus,
  Name,
  TransferredPieces,
  Compliance,
  SupervisorName,
  TransferredPiecesAbbr,
  CompositionTransfersMade,
  Corporate,
  BetweenStores,
  TopStoresGreaterPiecesTransferred,
  StoreName,
  ReturnedPieces,
  ComplianceApprovedReturns,
  ReturnedPiecesAbbr,
  CompositionReturnsMade,
  TopStoresGreaterPiecesWithReturn,
  HistoricalChecklist,
  CurrentMonth,
  AnnualAccumulated,
  Day,
  Month,
  MinComplianceAccepted,
  MadeInventories,
  UnitDifferences,
  CostDifferences,
  UnitsAbbr,
  TransfersBetweenStores,
  Returns,
  DifferencesByInventory,
  InventoryBySupervisor,
  TopStoresGreaterNumberDifferences,
  TotalNumberInventoriesMonth,
  InventoryType,
  Pieces,
  NumberDifferences,
  ActivitiesReport,
  Download,
  DownloadChangeLevelInstruction,
  ActivityType,
  SelectAnOption,
  NoAssignment,
  Search,
  Reference,
  ReferenceRequest,
  ActivityName,
  StartDate,
  EndDate,
  Progress,
  Status,
  ThereIsNoInformation,
  Store,
  ExecutionDate,
  Brand,
  NewActions,
  Section,
  Gender,
  StyleVariety,
  Description,
  Price,
  CompletedDate,
  AlertSelectActivityFirst,
  LevelOneTab,
  LevelTwoCard,
  LevelThreeTitle,
  Instruction,
  Answer,
  Comments,
  Photos,
  Generating,
  AlertOperationCouldNotBeCompleted,
  GettingImages,
  FailedToGetImages,
  Duration,
  Action,
  CommitmentDate,
  GoBack,
  ActivityScheduler,
  Consult,
  Edit,
  Program,
  Activity,
  Instructions,
  Periodicity,
  GettingChecklistList,
  AlertSelectRecordPerformSelectedAction,
  AlertUploadedFile,
  AlertNoUploadedFileFound,
  AlertSelectOnlyOneFile,
  AlertOnlyPDFfilesAreAccepted,
  AlertFileSizeExceedsAllowedWeight,
  File,
  UploadedCorrectly,
  AlertOnlyXlsxfilesAreAccepted,
  Row,
  EnterLevelName,
  MinimumNumberPhotosMaximumNumberPhotos,
  MinimumNumberPhotosCannotBeLesThan0,
  AlertSelectChecklistFunctionality,
  AlertEnterTheTitleOfTheChecklist,
  AlertSelectCampaignFromChecklist,
  AlertSelectOrganizationFromChecklist,
  AlertSelectPeriodicityOfTheChecklist,
  AlertSelectOneStoreForTheChecklist,
  AlertSelectIfYouRequireNotice,
  AlertSelectNoticeDate,
  AlertSelectNoticeDocument,
  AlertUploadFileWithNecessaryInstructions,
  AlertCouldNotSaveChecklist,
  AlertCouldNotEditChecklist,
  AlertEnterCampaignName,
  AlertSelectStartDateDeadline,
  AlertCampaignCreatedSuccessfully,
  AlertSelectCampaignToEdit,
  AlertCampaignSuccessfullyEdited,
  AlertSelectOrganization,
  Save,
  MandatoryInformation,
  GeneralData,
  ChecklistFunctionality,
  AssignedStores,
  SeeStores,
  Title,
  EnterTitle,
  AddCampaign,
  EditCampaign,
  Notice,
  RequiresNotice,
  NoticeDate,
  NoticeAttachedDocument,
  SelectAFile,
  Choose,
  RequiresReadingNotice,
  ActivityScheduling,
  Repeat,
  Monday,
  MondayAbbr,
  Tuesday,
  TuesdayAbbr,
  Wednesday,
  WednesdayAbbr,
  Thursday,
  ThursdayAbbr,
  Friday,
  FridayAbbr,
  Saturday,
  SaturdayAbbr,
  Sunday,
  SundayAbbr,
  LayoutDownload,
  UploadInstructionsFile,
  Detail,
  MinimumImages,
  MaximumImages,
  Answers,
  SelectStores,
  Filters,
  OpeningHours,
  ClosingHours,
  AllMayusA,
  AllMayusO,
  CheckUnchekAll,
  Accept,
  Deadline,
  Cancel,
  ValidityOfTheChecklist,
  RestrictChecklistHours,
  RequiresMaxExecutionTime,
  MaximumTimeRequired,
  LevelOne,
  CaptureMayus,
  Score,
  Message,
  TemplateManager,
  Template,
  DownloadTemplate,
  Weighing,
  Actions,
  RequiresTicket,
  CorrectiveActionsPerStore,
  End,
  ChecklistType,
  Pending,
  Closed,
  NotPerformed,
  LastQualification,
  Evaluator,
  LastEvaluation,
  YouMustConsultInforFirst,
  CorrectiveActionsDetail,
  Responsable,
  RequiredDate,
  SolutionDate,
  CorrectiveAction,
  Close,
  Society,
  Invoice,
  View,
  StoresReport,
  StoresReportChecklist,
  CumulativeTotal,
  StoreOpeningChecklist,
  StoreClosingChecklist,
  StoreOpeningChecklistUSA,
  StoreClosingChecklistUSA,
  SupervisorChecklist,
  SupervisorChecklistUSA,
  VIMChecklist,
  CorrectiveActions,
  AlertNoInfoToDownload,
  AlertTheStartDateCannotBeHigher,
  CompliancePercentage,
  CompositionPercentage,
  PercentageSent,
  PercentageReceived,
  AlertCannotGenerateReport,
  VisualMerchandiserChecklist,
  VisualMerchandiserChecklistUSA,
  AuditorChecklist,
  AuditorChecklistUSA,
  CoordinatorChecklist,
  CoordinatorChecklistUSA,
  ReturnToProvider,
  PhysicalInventory,
  Summary,
  TotalStocksTPV,
  TotalScannedQuantum,
  TotalDifferences,

  ScheduleActivities,
  Receptions,
  Incomes,
  StoreTransfers,
  ReturnsRequests,
  ManageStores,
  ManageDevicesAbbr,
  OrganizationalStructure,
  ManageEmployeesAbbr,
  ManageZonesAbbr,
  Indicators,
  Operation,
  Inventory,
  Configuration,
  LogOut,

  CEDISMerchandiseEntry,
  SelectStore,
  SelectStatus,
  Delivery,
  SendDate,
  Received,
  Entry,
  MerchandiseDetail,
  ShippingNumberDetail,
  FinishedA,
  Process,
  AlertNoDeliveryInfoWasObtained,

  TransportStartDateMayus,
  ShippingNumberIncludedMayus,
  ShippingNumberReceivedMayus,
  ShippingNumberReceivedByASNMayus,
  ShippingNumberReceivedWithoutASNMayus,
  ShippingNumber,
  ShippingNumberReceivedByASN,
  ShippingNumberReceivedWithoutASN,
  Date,
  Hour,
  ReceivedBy,
  ReferenceReception,
  CancelShippingNumber,
  YouReallyWantCancelShippingNumber,
  Yes,
  Not,

  ShippingNumberReceived,
  ViewComments,
  ViewPhotos,
  AlertErrorGettingInformation,

  MerchandiseTotalToEntryMayus,
  MerchandiseEntryMayus,
  MissingMerchandiseMayus,
  Style,
  Variety,
  Size,
  EntryBy,
  EntryDate,
  EntryReference,
  AlertErrorGettingCatalogs,

  ReceptionReport,
  Employee,
  Confirmation,
  CreateInventory,
  CreatedBy,
  InventoryReference,
  Counting,
  StockTPV,
  Tags,
  Unsubscribe,
  Export,
  AlertStoresCouldNotBeObtained,
  AlertOrganizationsCouldNotBeObtained,
  AlertInventoriesCouldNotBeObtained,
  AlertTitlesCouldNotBeObtained,
  AlertYouDoNotHaveThePermissionsToCreate,
  AlertYouDoNotHaveThePermissionsToEdit,
  AlertYouDoNotHaveThePermissionsToRemoveInventory,
  AlertThisInventoryDoesNotHaveCapturedData,
  AlertThereWasErrorConsultingDetailInventory,
  AlertInventoryDataCouldNotBeObtained,
  AlertCantDeleteInventory,
  Delete,
  Product,
  CountingQuantity,

  User,
  Profile,
  Scanned,
  AlertTheDataHasBeenUpdatedSuccessfully,
  AlertInfoMustBeLoadedToGenerateTheFile,
  Quantity,

  EditInventory,
  SAPpiecesQuantity,
  CreateFilter,
  CreateTags,
  AddAtag,
  AddTags,
  ReferenceTag,
  TagName,
  PrintTag,
  PrintAllTags,
  EnterNumberPieces,
  TagReference,
  AlertInventoryTypesCouldNotBeObtained,
  AlertBrandsCouldNotBeObtained,
  GettingTheStores,
  ObtainingTheTypesOfInventories,
  ObtainingTheBrands,
  GettingDepartments,
  AlertDepartmentsCouldNotBeObtained,
  GettingGenders,
  AlertGendersCouldNotBeObtained,
  AlertFilterCombinationCannotBeRepeated,
  AlertYouMustSelectTheBrand,
  AlertYouMustSelectTheDepartment,
  AlertYouMustSelectTheGender,
  AlertYouMustSelectTheTypeInventory,
  AlertYouMustSelectTheStore,
  AlertNumberTagsMustBegreater,
  AlertYouMustGenerateTheTags,
  AlertYouMustGenerateAtLeastOneFilter,
  GeneratingFilter,
  GeneratingTags,
  Tag,
  AlertCouldNotGetTheNextInventoryNumber,
  AlertYouMustHaveAtLeastOneTag,
  GeneratingInventory,
  AlertUnableSaveInventoryForTheStore,
  AlertYouDoNotHavePermissionsToPerformThisAction,
  Validation,
  Scanning,
  AlertYouMustCreateTheTagsBeforePrintingThem,
  AddingTag,
  AlertTheTagCouldNotBeAdded,
  RemovingTag,
  TagCouldNotBeDeleted,
  generatePDF,
  errorMessageGeneratePDF,

  SupplierReturnsRequests,
  OriginStore,
  RequestReference,
  Reason,
  RequestedQuantity,
  Shipment,
  RequestDate,
  ApprovalDate,
  LastShipmentDate,
  GettingReturnsRequests,
  AlertTheReturnRequestListCouldNotBeObtained,
  AletStoreListCouldNotBeObtained,
  ObtainingReturnReasons,
  AlertReturnReasonsCouldNotBeObtained,
  AlertStoreListCouldNotBeObtained,
  Approved,
  Pendiente,
  PendingRet,

  ReturnRequest,
  Approve,
  ReasonForReturn,
  Requested,
  ApprovedQuantity,
  Approval,
  Sent,
  AlertCouldNotGetTheRequestDetail,
  SavingInformation,

  ReturnsToSupplier,
  StoreReturnReference,
  ObtainingReturnsToSupplier,
  AlertReturnsToSupplierCouldNotBeObtained,

  ShippingType,
  AmountSent,
  AlertReturnDetailCouldNotBeObtained,

  DownloadReport,
  RequestTransfer,
  DownloadLayout,
  DestinationStore,
  TransferReference,
  ObtainingTheCorporateTransfers,
  ObtainingTransfersBetweenStores,
  ObtainingTransfersInTransit,
  AlertCorporateTransfersCouldNotBeObtained,
  GettingTheSectors,
  GettingTheWeeks,
  GettingOrganizations,
  AlertCouldNotGetTheSectors,
  AlertYouMustFillTheFieldsOfTheForm,
  SavingData,
  DeletingTransfer,
  AlertHasBeenRemovedSuccessfully,
  RequestNewTransfer,
  Week,
  Year,
  UploadTransferFile,
  ContinueSaving,
  CountryOperation,
  Transfer,
  Origin,
  Destination,
  CorporateDateRequested,
  Season,
  Rejected,
  RejectedQuantity,
  AlertTheTransfersCouldNotBeObtained,

  // Reporte de traspaso en tiendas
  TransferStoreEntry,
  EmployeeRecibedEntry,
  EmployeeConfirmedEntry,
  ReceivedDate,
  ArticlesEntered,
  FolioTransferEntryTitle,
  FoliosTransferEntryTitle,


  // Admin Tiendas
  AddStore,
  Country,
  Active,
  Inactive,
  ParticipateQuantum,
  RequierePaqueteria,
  MigradaNEModal,
  ReasonForClosure,
  ReopeningDate,
  Continue,
  ActivateStore,
  StoreWillBeActivated,
  DesactivateStore,
  AreYouSureToDeactivateStore,
  ParticipationQuantumWillBeActivated,
  RemoveParticipateQuantum,
  AreyouSureToDisableQuantumEngagement,
  AreyouSureToActivatedMigradaNE,
  AreyouSureToActivatedReqPaqueteria,
  AreyouSureToDisableMigradaNE,
  AreyouSureToDisableReqPaqueteria,
  AlertSelectClosingReason,
  AlertSelectReopeningDate,
  AlertStoreSuccessfullyUpdated,
  WareHouse,
  CcPayRoll,
  Sap,
  StoreCode,

  // Admin Tiendas Detalle
  MasterData,

  // Admin Tiendas Detalle - Datos Maestros
  BranchPlan,
  Attach,
  StoreNumberAbbr,
  ActiveStore,
  BrandType,
  Zone,
  Address,
  ExteriorNumber,
  InteriorNumber,
  Suburb,
  City,
  State,
  PostalCode,
  Phone,
  Mail,
  LatitudeCoordinate,
  LengthCoordinate,
  SellingMeters,
  TotalMeters,
  Capacity,
  OpeningDate,
  CoordinatorRegion,
  SupervisorZone,
  VIMZone,
  ExecutiveZone,
  Coordinator,
  Of,
  To,
  ScheduledReopeningDate,
  StoreClosure,
  ClosingDate,
  Schedules,
  ObtainingStoreData,
  GettingStoreHours,
  ObtainingClosureReasons,
  ObtainingListOfCountries,
  ObtainingListOfBrands,
  ObtainingListOfOrganizations,
  Organization,
  OrganizationImgCollectorAdd,
  GettingListOfStoreTypes,
  GettingListOfStoreLocations,
  GettingListOfZones,
  EnterStoreNumber,
  ChangesHaveBeenSavedSuccessfully,
  ErrorSavingTryAgain,
  OpeningHoursAreIncorrect,
  ClosingTimeIsIncorrect,
  EnterStoreName,
  SelectCountry,
  SelectStoreType,
  SelectStoreLocation,
  SelectBrandType,
  SelectZone,
  LatitudeMustBeEqual,
  LengthMustBeEqual,
  SelectStoreClosingReason,
  SelectScheduledReopeningDate,
  SelectClosingDate,
  BlueprintNotBeenUploaded,
  Consignee,
  CostCenter,
  HumanTalentExecutive,
  Contract,
  ContractSignatureDate,
  SquareMetersContract,
  Expansion,
  TotalSquareMeters,
  SquareMetersSaleFloor,
  SquareMetersMezzanine,
  SquareMetersWarehouse,
  EnterValidNumberConsigneeField,

  // Quantum-Store
  ServiceUrl,
  Devices,
  SerialCode,
  Identifier,
  Model,
  AssignedStore,
  CurrentStore,
  LastOnlineEvent,
  APKVersion,
  Unassigned,
  GettingStoreDevices,

  // Administración de Dispositivos
  ManageDevices,
  Add,
  DeviceType,
  GettingDeviceList,
  AddDevice,
  EditDevice,
  SelectARecordToEdit,
  DeviceRegisteredSuccessfully,
  DeviceEditedSuccessfully,
  FillInAllTheFieldsMarked,
  SelectStoreToWhichTheDeviceAssigned,

  // Administración de tiendas por usuario
  StoreManagementByUser,
  Position,
  TheOrganizationChartCouldNotBeDisplayed,
  DeletingUser,
  CouldNotDeleteThisUser,

  // Administración de tiendas por usuario - Detalle
  Validating,
  AllO,
  None,
  AddEmployee,
  SaveEmployee,
  EditEmployee,
  SaveChanges,
  PositionsWereNotObtained,
  ThereWasAnErrorGettingTheStores,
  InvalidEmail,
  MissingAddEmail,
  SomeFieldsAreMissing,
  ThePlaceWasNotSaved,
  ThePlaceWasNotUpdated,
  EmployeeName,
  CleanData,
  AllStores,
  CountriesWereNotObtained,

  // Administración de empleados
  Employees,
  RegisterEmployee,
  EmployeeNumber,
  Email,
  EmployeeDetail,

  // Administrador de zonas
  Region,
  CouldNotGetTheZones,
  ItIsNotPossibleToDeleteAnAreaWithAssignedStores,
  AreYouSureToDeleteTheZone,
  GettingRegions,
  CouldNotGetTheRegions,
  InvalidZoneName,
  CantSave,
  SelectRegion,
  ZoneCreatedSuccessfully,
  ZoneEditedSuccessfully,
  ZoneDeletedSuccessfully,
  ManageZones,
  AddZone,
  EditZone,
  StoresAvailable,
  DeleteZone,

  // Administrar Modulos
  ManageModulesMenu,
  ManageModulesTitle,
  ManageModulesRowName,
  ManageModulesRowStores,
  ManageModulesSuccessMessage,

  // InventoryDetail
  TitleScannedProductSummary,
  TitleInventoryFilters,
  TitleDiferencesReportStyleVariety,
  TitleScansPerformedByProduct,
  QuantumScanned,
  StocksTPV,

  // InventoryCount
  AlertOrganizationInfoCouldNotBeObtained,
  AlertConfigurationInfoCouldNotBeObtained,
  GettingOrganization,
  GettingEnglishOrganization,
  PrintingTags,
  DeleteInventory,
  MessageDeleteInvetory,

  // StoreReport
  Checklist,

  // StoreReport ChangeLevel
  AlertCouldNotGetChangeLevelInstruction,
  // Consignment
  Consigment,
  DateTransfer,
  DateTransite,
  Red,
  Yellow,
  Green,

  // Inventory
  InventoryDeletedSuccessfully,
  Import,
  ImportFile,
  IncorrectLayout,
  Restock,
  RestockChampions,
  ReinforceCentralSizes,
  NewBasics,
  RestockSave,
  RestockStatus,
  Stock,
  Sell,
  RestockReport,
  UnitsDetail,
  CR,
  NB,
  RTC,
  Strategy,
  ASNMerchandiseEntry,

  PreIroned,
  TheoreticalFile,
  ChargeEntry,
  Sales,
  WareEntry,
  EndingTheoreticalInventory,
  Concept,
  TitleInfo,
  Total,
  GenerateDetail,
  SKU,
  Completed,
  WithError,
  WithoutProcess,
  FileTypeNoSupported,
  Physical,

  // Image Collector
  ImageCollector,
  CreateImageCollector,
  Module,
  ModuleImgCollectorAdd,
  MSGInvalidFormat,
  AlertOnlyImgfilesAreAccepted,
  AlertCouldNotSaveImageCollector,
  AlertCouldNotSaveImageCollectorLogIn,
  AlertCouldNotSaveImageCollectorCmbModuleNotSelected,
  AlertCouldNotSaveImageCollectorCmbOrganizationNotSelected,
  AlertCouldNotSaveImageCollectorImgNotLoaded,
  AlertCouldNotLoadImage,
  CreateImage,
  Activate,
  ActivateImage,
  ImageWillBeActivated,
  SaveImageConfirmationAllOrganizations,
  SaveImageConfirmation,
  SaveImage,
  ImageCollectorUpdateSuccessfully,
  ImageCollectorSaveSuccessfully,

  // Load Image
  DragnDrop,
  Or,
  BrowseForFile,

  // Tenant
  AlertThisUserDoesNotBelongATenantAvailable,
  AlertThereWasErrorConsultingTenant,
  AlertTenantDataCouldNotBeObtained,
  TenantNotAvailable,
  Tenant,
  MigradaNE,
  ReqPackage,
  CouldNotGetTenant,

  // Organization
  CouldNotGetOrganizations,
  AvailableOrganizations,
  OrganizationStores,

  // Transfer Request
  AlertTransfersCouldNotBeObtained,
  ErrorTransferSector,
  ErrorTransferStoreOriginDestiny,
  ErrorTransferStoreNotOnlyMigrated,
  ErrorTransferStoreOrganization,
  ErrorTransferOrganization,
  ErrorTransferStyleOrganization,
  ErrorTransferStyleVariety,
  ErrorTransferStyleSizeOrganization,
  ErrorTransferStyleSize,
  ErrorTransferStyleQuantity,
  ErrorTransferStyleSizeMultiRow,
  ErrorTransferTaskCreate,
  ErrorTransferCountToCreate,
  ErrorTransferWithDetCreate,
  ErrorTransferDuplicateToday,
  ErrorTransferMaxVersionsReached,
  ErrorTransferMaxVersionsPartial,
  ErrorTransferMaxVersionsPartialConfirm,
  ErrorTransferNetworkRetry,
  ErrorTransferBatchPartial,
  Retry,
  TransferRequestCreatedSuccessfully,
  DuplicateWillCreateWithSuffix,
  DuplicateBlockedByMaxVersions,
  DuplicateExistingCode,
  DuplicateWillBeCreatedAs,
  DuplicateConfirmMessage,
  DuplicateSummaryNewTransfers,
  UnprocessedRecords,
  DeactivateRequests,
  DeactivateSuccess,
  DeactivateConfirm,
  DeactivateSuccessCount,
  DeactivateFailedCount,
  DeactivateStoppedByLock,
  DeactivateIrreversibleWarning,
  DeactivateHoldToConfirm,
  DeactivateScheduledFor,
  Selected,
  ValidatingStores,
  ValidatingStyles,
  ValidatingDuplicates,
  CreatingRequests,
  ConfirmLeaveWhileProcessing,

  // Transfer Store
  PackageCollectionDate,
  EmployeeCollectionConfirm,
  GuideCollection,
  CommentCollection,

  // Default
  ErrorUnknown,
  AllSelected,
  SmallerDateThan,
  GreaterDateThan,
  Empty,

  // Label Design
  LabelDesign,
  PriceType,
  LabelType,
  LabelOriginaPrice,
  LabelSalePrice,
  AditionalRow,
  PercentDiscount,
  SelectLabelType,
  SelectBarcodeType,
  SelectAditionalRow,
  PriceLabelSuccessfully,

  // Barcode examples
  SkuExampleCode,
  UPCExampleCode,
  EANExampleCode,

  // PreIroned Inventory
  Failures,
  ErrorMessageGenerateDetails,
  FailureDate,
  FailureType,
  StoreCharge,
  FactoryCharge,
  Regularization,
  ThereAreErrorNoDownload,
  NoFileCharged,

  // Dashboard WareEntry
  WareEntryDetail,
  DownloadInvoice,
  AmountReceived,
  AmountEntry,
  EnteredTo100,
  EnteredWithDiff,
  PendingToEntry,
  BilledUnits,
  UnitsEntered,
  NumInvoices,
  Percentage,
  DiffAmountSentEntry,
  DiffDaysReceivedEntry,
  DiffDaysSentReceived,
  GuideNumber,
  Provider,
  FolioSAC,

  //Returns
  PiecesForReturn,
  SeeSettings,
  AlertEnterAnAmount,
  NoticeReturnConfiuration,
  AlertAmountMustGreaterThan0,
  CorporateReturns,
  ReferenceRequestReturn,
  RequestReturn,
  UploadReturnFile,
  Division,
  CedisPlant,
  EventLog,
  MaximiumDateRequired,
  EmptyLayout,
  Cedis,

  // Store 
  SelectAStore,

  // Invoicement
  Invoicement,
  Invoices,
  Requester,
  InvoicementDate,
  CreationDate,
  BoxQuantity,

  DetailShipmentGuides,
  Expiration,
  PartialEntry,
  CompleteEntry,
  UnknownStatus,
  Without_Reception,

  // Logger Layouts
  LoggerLayout,
  LayoutCode,
  Username,
  IncidenceWithLayout,
  IncidenceDate,

  Sector,

  // Title dialogs
  warningMessage,
  AdviceSelectOptionStoreField,
  StatusTask,
  NoOrganizationAssigned,
  
  // store report checklist
  Executive,
  ScoreExt,
  ScoreInt,
  ScoreVar,
  ActivityDate,

  // Users Admin
  UsersAdmin,
  Account,
  ActiveDirectory,
  Domain,
  Password,
  ApiUser,
  CustomUser,
  Confirmed,
  UserSavedSuccessfully,
  UserSaveFailed,
  AdminRoles,
  Roles,
  RolesUpdatedSuccessfully,
  RolesUpdateFailed,
  AreYouSureDefault,
  Permissions,
  UserMustHaveOnlyOneRole,
  UserAlreadyExists,
  UserEditError,
  ErrorGettingRoles,
  ErrorSavingRoles,
  ErrorGettingData,
  ErrorGettingPermissions,
  ErrorSavingPermissions,
  GeneratePassword,

  // Unsold Item Size
  UnsoldItemSize,

  // Inventory Report
  InventoryReport,
  Canceled,
  Manifest,
  ManifestNumber,
  ParcelGuide,
  Guide,
  ASNCodes,
  ASNCode,
  CartonCode,
  DetailCartonGuide,
  EntryInventory,
  ShipmentASNDetail,
  ReceptionDate,
  StylesVarietyASN,
  sizeGroupDetCode,
  styles,
  ExportFileNamePendingTransfers,
  // Feature 46570 - Carga de Traspasos de ROi
  BulkMyUploads,
  BulkUploadDetail,
  BulkUploadStartedNotice,
  BulkJobFinishedNotice,
  BulkSuccess,
  BulkFailed,
  BulkDownloadFailed,
  BulkNoFailedRecords,
  BulkLoadingDetail,
  BulkStatusQueued,
  BulkStatusProcessing,
  BulkStatusDone,
  BulkStatusCompletedWithErrors,
  BulkStatusFailed,
  BulkStartedDate,
  BulkFinishedDate,
  BulkRowCreated,
  BulkRowFailed,
  BulkRowSkipped,
  Refresh,
  ViewDetail,
  WhatsNewTitle,
  WhatsNewLink,
  WhatsNewAdded,
  WhatsNewImproved,
  WhatsNewFixed,
  WhatsNewGotIt
}
  